import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Empty } from 'antd'
import { inject, observer } from 'mobx-react'
import { TYPE_STATUS } from '../../constants'
import { AvatarHasName } from '../../components/Common/Avatar'
import { StatusTag } from '../../components/Common/StatusTag'
import { pickBy } from 'lodash'
import { AppTable } from '../../components/AppTable/AppTable'
import { AppTablePagination } from '../../components/AppTable/AppTablePagination'
import queryString from 'query-string'
import { useHistory, useLocation } from 'react-router-dom'

const ShoppingCouponTable = props => {
  const [isLoading, setIsLoading] = useState(false)

  const [shoppingData, setShoppingData] = useState([])
  const [totalCount, setTotalCount] = useState(0)

  const [allUsers, setAllUsers] = useState([])
  const [allUserr, setAllUserr] = useState([])

  const {
    ShoppingCouponStore,
    userStore,
    loadingAnimationStore,
    refreshData,
  } = props

  const history = useHistory()
  const location = useLocation()

  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  const { getAllShoppingCouponV2 } = ShoppingCouponStore

  useEffect(() => {
    loadingAnimationStore.setTableLoading(true)
    const fetchUserLists = async () => {
      try {
        const [userList1, userList2] = await Promise.all([
          userStore.getMentionUserList(true),
          userStore.getMentionUserList(),
        ])

        const formattedUsers1 = userList1.data.userDetails.map(user => ({
          id: user.userCode,
          fullName: user.fullName,
          username: user.user_name,
          image: user.image,
        }))

        const formattedUsers2 = userList2.data.userDetails.map(user => ({
          id: user.userCode,
          fullName: user.fullName,
          username: user.user_name,
          image: user.image,
        }))

        setAllUsers(formattedUsers1)
        setAllUserr(formattedUsers2)
      } finally {
        loadingAnimationStore.setTableLoading(false)
      }
    }

    fetchUserLists()

    return () => userStore.clearStore()
  }, [userStore])

  const mergedShoppingData = useMemo(() => {
    const finalUserData = [...allUsers, ...allUserr]

    const userMap = new Map(finalUserData.map(item => [item.username, item]))

    return (shoppingData || []).map(record => {
      const match = userMap.get(record.createdUser)

      return match
        ? {
            ...record,
            image: match.image,
            fullName: match.fullName,
          }
        : record
    })
  }, [shoppingData, allUsers, allUserr])

  const handlePaginationChange = (page, pageSize) => {
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        page: page - 1,
        size: pageSize,
      },
      {
        skipNull: true,
      }
    )
    history.push({
      search: queryStringStringify,
    })
  }

  const handleFetchShoppingCouponList = useCallback(async () => {
    try {
      setIsLoading(true)
      const queryParams = {
        page: queryStringParse?.page || 0,
        size: queryStringParse?.size || 10,
        title: queryStringParse?.title || null,
        createUser: queryStringParse?.createUser,
        createdDate: queryStringParse?.createdDate,
        type: queryStringParse?.type,
        userType: queryStringParse?.userType,
      }
      const formattedQueryPayload = pickBy(queryParams, v => v != null)

      const response = await getAllShoppingCouponV2(formattedQueryPayload)
      const total = response.data.totalElements

      setShoppingData(response?.data?.content || [])
      setTotalCount(total || 0)
    } finally {
      setIsLoading(false)
    }
  }, [getAllShoppingCouponV2, queryStringParse])

  useEffect(() => {
    handleFetchShoppingCouponList()
  }, [handleFetchShoppingCouponList, refreshData])

  const tableColumns = [
    {
      title: 'Tiêu đề ',
      width: 250,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 'auto',
          }}>
          <div title={record?.title}>{record?.title}</div>
        </p>
      ),
      onCell: (record, rowIndex) => {
        return {
          onClick: ev => {
            history.push(`/shopping-coupon/other/view/${record.code}`)
          },
        }
      },
    },
    {
      title: 'Ngày tạo',
      align: 'center',
      width: 50,
      render: record => {
        const date = new Date(record?.createdDate || 0)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')

        const formattedDate = `${day}/${month}/${year}`
        return (
          <div
            style={{
              marginBottom: '0px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            {formattedDate}
          </div>
        )
      },
      onCell: (record, rowIndex) => {
        return {
          onClick: ev => {
            history.push(`/shopping-coupon/other/view/${record.code}`)
          },
        }
      },
    },
    {
      title: () => {
        return <p style={{ marginBottom: '0px' }}>Người tạo</p>
      },
      width: 90,
      // align: 'center',
      render: record => (
        <div
          style={{
            display: 'flex',
            marginBottom: '0px',
            alignItems: 'center',
          }}>
          <AvatarHasName imgId={record?.image} name={record?.fullName} />
        </div>
      ),
      onCell: (record, rowIndex) => {
        return {
          onClick: ev => {
            history.push(`/shopping-coupon/other/view/${record.code}`)
          },
        }
      },
    },
    {
      title: 'Trạng thái',
      width: 70,
      align: 'center',
      render: record => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {StatusTag(TYPE_STATUS.PROCUREMENT, record.type)}
        </div>
      ),
      onCell: (record, rowIndex) => {
        return {
          onClick: ev => {
            history.push(`/shopping-coupon/other/view/${record.code}`)
          },
        }
      },
    },
  ]

  return (
    <>
      <AppTable
        rowKey={record => record.code}
        dataSource={mergedShoppingData}
        columns={tableColumns}
        pagination={false}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={'Không có dữ liệu'}
            />
          ),
        }}
        loading={isLoading}
      />

      <AppTablePagination
        pageSize={Number(queryStringParse?.size || 10)}
        current={Number(queryStringParse?.page || 0) + 1}
        total={totalCount}
        onChange={handlePaginationChange}
      />
    </>
  )
}

export default inject(
  'authenticationStore',
  'selectPeopleStore',
  'ShoppingCouponStore',
  'userStore',
  'loadingAnimationStore'
)(observer(ShoppingCouponTable))
